
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1591771112298",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "14907",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "500",
    "height": "500"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z",
        "fill": "#1890ff",
        "p-id": "14908"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M328.192 748.288A44.288 44.288 0 0 1 284.032 704v-103.424a14.208 14.208 0 0 1 4.096-10.112 25.6 25.6 0 0 1 10.112-4.224 132.736 132.736 0 0 0 58.496 12.16c22.784 0 51.2-25.6 80.768-25.6 24.576 0 51.2 24.576 76.8 24.448s55.296-25.6 80.896-25.6c30.208 0 57.6 27.136 78.848 29.824 25.6 3.2 42.496-18.048 45.312-18.048a14.336 14.336 0 0 1 14.208 14.336V704a44.416 44.416 0 0 1-44.16 44.544H328.32z m23.296-190.08a100.736 100.736 0 0 1-44.288-9.472v-1.92h-3.712a101.12 101.12 0 0 1-52.224-88.704 102.4 102.4 0 0 1 4.736-31.616 18.304 18.304 0 0 1 0-1.92l48.384-115.2a50.048 50.048 0 0 1 49.92-33.152h316.288a52.48 52.48 0 0 1 51.2 34.304L767.232 422.4a11.776 11.776 0 0 1 0.768 2.304v1.152a99.328 99.328 0 0 1 4.864 30.976 101.248 101.248 0 0 1-52.352 88.96 102.4 102.4 0 0 1-125.056-24.448l-3.84-4.608-3.84 4.608a98.688 98.688 0 0 1-152.32 0l-3.84-4.48-3.84 4.48a100.096 100.096 0 0 1-76.8 36.096z m3.584-119.296a14.336 14.336 0 0 1 0-28.544h307.2a14.336 14.336 0 0 1 0 28.544z",
        "fill": "#FFFFFF",
        "p-id": "14909",
        "data-spm-anchor-id": "a313x.7781069.0.i4",
        "class": "selected"
      }
    }
  ]
})
    }
  